/**
 * Created by aresn on 17/3/29.
 */
"use strict";
import Env from './env';
var config = {
  env: Env
};
//根据环境不同配置不同参数
config.mode = 'history'
if (Env == 'development') {
    config.api = 'http://www.gjypzc.cn/api'  //本地接口
	//config.api = 'http://pmsl.ccm.cn/api';  //本地接口
  // config.api = 'http://ccm.tunnel.echomod.cn/api'  //本地接口http://ccm.tunnel.echomod.cn/
} else {
  config.api = 'http://www.gjypzc.cn/api'  //网络接口
}
export default config;





// WEBPACK FOOTER //
// ./src/config/config.js